import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { config } from '../../shop.config.custom';

const BrandWrapper = styled('div')``;

/*const Image = ({ subName }) => (
  <img
    src={
      '/pub_images/small/' +
      subName.replace(/[^a-z0-9]/gi, '_').toLowerCase() +
      '.png'
    }
    alt={subName}
    title={subName}
  />
);*/

const NameOrImage = ({ subName }) => {
  //return <Image subName={subName} />;
  return <p>{subName}</p>;
};

export const Brand = ({ product }) => {
  if (!product) return null;

  const subName = product.subName;

  const currentCategory = product.categories?.filter((cat) =>
    config.routes.brand.id.includes(cat.parentId)
  )[0];

  return (
    <BrandWrapper>
      <>
        {currentCategory ? (
          <CategoryLink category={currentCategory}>
            <NameOrImage subName={subName} />
          </CategoryLink>
        ) : (
          <NameOrImage subName={subName} />
        )}
      </>
    </BrandWrapper>
  );
};
